import { CSShiftTimeGroup, CSShiftType, OMSShiftType, ShiftType } from '@/api/apis/resources/schedule';

export const shiftTypeNames: Record<ShiftType, string> = {
  [OMSShiftType.AdminDay]: 'Admin Day',
  [CSShiftType.AtHub]: 'At Hub',
  // [CSShiftType.OfficeDay]: 'Office Day',
  [CSShiftType.OfficeDay]: 'Admin Day',
  [CSShiftType.NoCall]: 'No Call',
  [CSShiftType.OnCall]: 'On Call',
  [CSShiftType.Sick]: 'Sick Leave',
  [OMSShiftType.SickLeave]: 'Sick Leave',
  [CSShiftType.PhoneSupport]: 'Clinical Lead',
  [CSShiftType.Unavailable]: 'Unavailable',
  [CSShiftType.Vacation]: 'Vacation',
  [CSShiftType.WeekendOff]: 'Weekend Off',
  [CSShiftType.TravelDay]: 'Travel Day',
};

export const shiftTimeGroupNames: Record<CSShiftTimeGroup, string> = {
  [CSShiftTimeGroup.GroupA]: 'A',
  [CSShiftTimeGroup.GroupB]: 'B',
};
